import { Component } from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { searchBar } from "./SearchStyles";
import Icon from "../../common/components/UI/Icon";
import { colors } from "../../common/styles/Colors";
import { connect } from "react-redux";
import actionCreators from "../../store/CampusMapping/actionCreators";
import { Subject } from "rxjs/Subject";
import GTM from "../../common/services/GTM";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

class SearchField extends Component {
    state = {
        filter$: new Subject(),
    };

    componentDidMount() {
        this.clearSearch();
    }

    clearSearch = () => {
        const { getSearchResults, clearSearchResults, setQuerySearch } = this.props;
        const { filter$ } = this.state;

        this.searchInput.value = "";
        setQuerySearch("");
        clearSearchResults();

        filter$.pipe(debounceTime(500), distinctUntilChanged()).subscribe(value => {
            if (value !== "") {
                getSearchResults({ filter: value });
                setQuerySearch(value);
                GTM.dispatch({
                    event: "newSearch",
                    actionType: "Map search",
                    searchQuery: `${value}`,
                });
            } else clearSearchResults();
        });
    };

    componentDidUpdate(prevProps) {
        if (prevProps.isSearchActive !== this.props.isSearchActive && !this.props.isSearchActive) {
            this.clearSearch();
        }
    }

    render() {
        const {
            isSearchActive,
            searchResults,
            toggleSearchActive,
            mode,
            isMasqueraded,
        } = this.props;
        const { filter$ } = this.state;

        const { clearSearch } = this;

        return (
            <div
                css={[
                    searchBar.body,
                    searchBar.bodyMap,
                    isSearchActive && searchBar.bodyIsSearchActive,
                    isMasqueraded && searchBar.bodyMapIsMasqueraded,
                ]}
            >
                <div css={searchBar.inner}>
                    <div css={searchBar.elementLeft}>
                        <Icon
                            name="search"
                            fill={colors.black20}
                            width={18}
                            height={18}
                            css={searchBar.iconSearch}
                        />
                        {isSearchActive ? (
                            <button
                                css={[searchBar.btnBack, searchBar.btnBackMap]}
                                onClick={() => toggleSearchActive()}
                                type="button"
                            >
                                <Icon
                                    name="arrowLeft"
                                    fill={colors.black87}
                                    width={18}
                                    height={18}
                                />
                            </button>
                        ) : (
                            mode !== "DETAIL" && (
                                <Icon
                                    name="search"
                                    fill={colors.black20}
                                    width={18}
                                    height={18}
                                    css={searchBar.iconSearchMobile}
                                />
                            )
                        )}
                    </div>
                    <div css={searchBar.elementCenter}>
                        <input
                            onInput={e => filter$.next(e.target.value)}
                            css={searchBar.input}
                            placeholder="Search"
                            onFocus={() => !isSearchActive && toggleSearchActive()}
                            ref={e => (this.searchInput = e)}
                        />
                    </div>

                    {searchResults && (
                        <div css={searchBar.elementRight}>
                            <button type="button" css={searchBar.btn} onClick={() => clearSearch()}>
                                <Icon name="times" fill={colors.black87} width={16} height={16} />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ CampusMapping: { isSearchActive, searchResults } }) => ({
    isSearchActive,
    searchResults,
});

const mapDispatchToProps = {
    toggleSearchActive: actionCreators.toggleSearchActive.create,
    getSearchResults: actionCreators.getSearchResults.create,
    clearSearchResults: actionCreators.clearSearchResults.create,
    setQuerySearch: actionCreators.setQuerySearch.create,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchField);
